import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import ContentBox from 'components/CncUI/ContentBox';
import Button from 'components/CncUI/Button';
import Typography from 'components/CncUI/Typography';
import Link from 'components/CncUI/Link';

import support from 'constants/config/support';
import trophy from 'images/trophy.svg';

const useStyles = makeStyles(({ breakpoints }) => ({
  root: {
    marginTop: 56,
    marginBottom: 40,
  },
  hide: {
    [breakpoints.down('md')]: {
      display: 'none',
    },
  },
  content: {
    padding: '40px 20px 48px',
  },
  center: {
    textAlign: 'center',
  },
  box: {
    margin: '40px auto',
    [breakpoints.up('md')]: {
      padding: '40px 80px 50px',
      width: 662,
    },
    [breakpoints.down('sm')]: {
      width: 'auto',
      padding: '40px 20px',
    },
  },
  card: {
    width: 388,
    [breakpoints.only('xs')]: {
      width: 'auto',
    },
    '& .MuiCardContent-root': {
      padding: '24px 16px 32px',
    },
  },
}));

const ThankYou = () => {
  const classes = useStyles();
  const supportInfo = support.helpDesk;
  const supportMsInfo = support.mediaServices;

  return (
    <>
      <Grid container spacing={2} className={classes.root}>
        <Grid item lg={2} md={0} className={classes.hide}>
          {' '}
        </Grid>
        <Grid item xs={12} md={8} lg={5}>
          <ContentBox className={classes.content} id="ThankYou">
            <Grid container spacing={7} className={classes.center}>
              <Grid item xs={12}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Typography h3 noMargin>
                      Thank you for registering
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography body2 short noMargin>
                      Check your inbox for an email containing a link to
                      activate and secure your account. <br />
                      <br />
                      You should receive an email within 24 hours if your
                      information matches our records. If not, contact our
                      Employee Help Desk.
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <img src={trophy} alt="Verified trophy" />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </ContentBox>
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <ContentBox className={classes.content}>
                <Grid container spacing={4} className={classes.center}>
                  <Grid item xs={12}>
                    <Typography h4 noMargin>
                      Support
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} style={{ paddingBottom: 4 }}>
                        <Typography h5>Employee Help Desk</Typography>
                        <Typography caption medium noMargin>
                          Email
                        </Typography>
                        <Typography body1 short noMargin>
                          <Link href={supportInfo?.email?.link}>
                            {supportInfo?.email?.display}
                          </Link>
                        </Typography>
                        <Typography
                          caption
                          medium
                          noMargin
                          style={{ marginTop: 8 }}
                        >
                          Phone
                        </Typography>
                        <Typography body1 short noMargin>
                          <Link href={supportInfo?.phone?.link}>
                            {supportInfo?.phone?.display}
                          </Link>
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        style={{ marginTop: 0, paddingTop: 0 }}
                      >
                        <Typography h5>{supportMsInfo.title}</Typography>
                        <Typography caption medium noMargin>
                          Email
                        </Typography>
                        <Typography body1 short noMargin>
                          <Link href={supportMsInfo?.email?.link}>
                            {supportMsInfo?.email?.display}
                          </Link>
                        </Typography>
                        <Typography
                          caption
                          medium
                          noMargin
                          style={{ marginTop: 8 }}
                        >
                          Phone
                        </Typography>
                        <Typography body1 short noMargin>
                          <Link href={supportMsInfo?.phone?.link}>
                            {supportMsInfo?.phone?.display}
                          </Link>
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </ContentBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ThankYou;
